// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","tertiary":"#BFD730","options":"_3bEG","active":"_13zm"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ScreenshotsCarousel/ScreenshotsCarousel.scss
// module id = 3m/6
// module chunks = 0